import React, { Component } from 'react';
import { Table, Row, InputNumber, Col, Button, DatePicker, message, Spin, Select, Input } from 'antd';
import moment from 'moment';
import './index.scss';
import { data2_1 } from './data';
import imgSave from "../../saveImg";
import Auth from "../../Auth";
import Compared from "../../Compared";
import ExportExcel from "@/method/components/ExportExcel"
const { MonthPicker } = DatePicker;
const Option = Select.Option;
const { TextArea } = Input;


class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            loading: true,
            loadingSave: false,
            note: {
                note: ""
            },
            print: false
        }
    }


    componentDidMount() {
        this.getDateData(this.state.date);
    }



    computeNum = (data) => {
        const numConvert = (num = 0) => {
            num = Number(num || "0")
            return num
        }

        const totalNum = [4, 6, 8, 9, 13, 14, 15, 19, 20, 21];
        const totalName = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

        // // 早餐划归餐饮部金额
        // for (let index = 0; index < totalName.length; index++) {
        //     data[8][totalName[index]] = (numConvert(data[7][totalName[index]]) + numConvert(data[6][totalName[index]])).toFixed(4);
        // }

        for (let index = 0; index < totalNum.length; index++) {
            data[totalNum[index]].whole = totalName.reduce((a, b) => {
                a += numConvert(data[totalNum[index]][b]);
                return a
            }, 0);
            data[totalNum[index]].whole = data[totalNum[index]].whole.toFixed(4);
        }

        data[7].last = (numConvert(data[6].last) == 0 ? 0 : (numConvert(data[5].last) / numConvert(data[6].last))).toFixed(3);

        const otherName = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'whole', 'last'];
        for (let i = 0; i < otherName.length; i++) {
            data[3][otherName[i]] = (numConvert(data[2][otherName[i]]) == 0 ? 0 : (numConvert(data[4][otherName[i]]) / numConvert(data[2][otherName[i]]))).toFixed(3);
            data[5][otherName[i]] = (numConvert(data[4][otherName[i]]) == 0 ? 0 : (numConvert(data[6][otherName[i]]) / numConvert(data[4][otherName[i]]))).toFixed(3);

            if (otherName[i] != 'whole' && otherName[i] != 'last') {
                data[8][otherName[i]] = (numConvert(data[6][otherName[i]]) * numConvert(data[7][otherName[i]])).toFixed(4);
            }
            // if (otherName[i] != 'whole' || otherName[i] != 'last') {
            //     data[10][otherName[i]] = (numConvert(data[8][otherName[i]]) == 0 ? 0 : (numConvert(data[9][otherName[i]]) / numConvert(data[8][otherName[i]]))).toFixed(3);
            // }

            data[10][otherName[i]] = (numConvert(data[8][otherName[i]]) == 0 ? 0 : (numConvert(data[9][otherName[i]]) / numConvert(data[8][otherName[i]]))).toFixed(3);
            data[11][otherName[i]] = (numConvert(data[8][otherName[i]]) - numConvert(data[9][otherName[i]])).toFixed(4);
            data[16][otherName[i]] = (numConvert(data[14][otherName[i]]) == 0 ? 0 : (numConvert(data[15][otherName[i]]) / numConvert(data[14][otherName[i]]))).toFixed(3);
            data[17][otherName[i]] = (numConvert(data[13][otherName[i]]) == 0 ? 0 : (numConvert(data[14][otherName[i]]) / numConvert(data[13][otherName[i]]))).toFixed(3);
            data[18][otherName[i]] = (numConvert(data[14][otherName[i]]) == 0 ? 0 : (numConvert(data[19][otherName[i]]) / numConvert(data[14][otherName[i]]))).toFixed(4);

            data[22][otherName[i]] = (numConvert(data[21][otherName[i]]) + numConvert(data[20][otherName[i]])).toFixed(4);
            data[23][otherName[i]] = (numConvert(data[14][otherName[i]]) == 0 ? 0 : (numConvert(data[22][otherName[i]]) / numConvert(data[14][otherName[i]]))).toFixed(4);
            data[24][otherName[i]] = (numConvert(data[19][otherName[i]]) - numConvert(data[20][otherName[i]]) - numConvert(data[21][otherName[i]])).toFixed(4);
        }

        // 早餐划归餐饮部金额 全年预测
        data[8].whole = totalName.reduce((a, b) => {
            a += numConvert(data[8][b]);
            return a
        }, 0);
        data[8].whole = data[8].whole.toFixed(4);
        // 单份早餐配给金额 整年单独结算
        data[7].whole = (numConvert(data[6].whole) == 0 ? 0 : numConvert(data[8].whole) / numConvert(data[6].whole)).toFixed(3);
        // 单份早餐去年
        data[7].last = (numConvert(data[6].last) == 0 ? 0 : numConvert(data[8].last) / numConvert(data[6].last)).toFixed(3);
        for (let i = 0; i < data.length; i++) {
            if (i != 0 || i != 1 || i != 12) {
                data[i].variance = (numConvert(data[i].last) == 0 ? 0 : (numConvert(data[i].whole) / numConvert(data[i].last))).toFixed(3);
            }

        }

        this.setState({
            data,

        });
    }
    onChange = (name, value, i) => {
        let data = this.state.data;
        i++
        data[i][name] = value;
        this.computeNum(data);
    }

    getDateData = (date) => {
        const dataBegin = JSON.stringify(data2_1);
        let data = JSON.parse(dataBegin);
        fetch(`/_5_5_all_info?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            const nameData = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'whole'];
            if (x.data.d5_5 && x.data.d5_5.length > 0) {
                // let dataNow = x.data.d5_5.filter(item => item.month == moment(date).format("MM"));
                // if (dataNow && dataNow.length > 0) {
                //     data = dataNow;
                // }
                // let dataLast = x.data.d5_5.filter(item => item.month == (moment(date).format("MM") - 1));
                // let len = moment(date).format("MM") - 1;
                // // 从上月数据中填充历史数据
                // if (dataLast && dataLast.length > 0) {
                //     for (let i = 0; i < len; i++) {
                //         data = data.map((z, index) => ({ ...z, [nameData[i]]: dataLast[index][nameData[i]] == 0 ? z[nameData[i]] : dataLast[index][nameData[i]] }));
                //     }
                // }
                data = x.data.d5_5;
            }
            if (x.data.d2_1 && x.data.d2_1.length > 0) {

                for (let index = 0; index < nameData.length; index++) {
                    data[2][nameData[index]] = x.data.d2_1[2][nameData[index]];
                }
            }
            let note = {};
            if (x.data.d5_5_1 && x.data.d5_5_1.length > 0) {
                note = { ...x.data.d5_5_1[0] }
            }
            this.setState({ loading: false, note });
            this.computeNum(data);
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }

    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");

        let data = this.state.data.map(x => ({ ...x, year, }));
        let dataFrom = new FormData();
        if (this.state.note.note) {
            this.onSaveNote([{ ...this.state.note, year, }])
        }
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/add_5_5', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getDateData(date);
                }
                return
            }

            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    onSaveNote = (data) => {
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/add_5_5_1', headres).then(x => x.json()).then(x => {
            if (x.status == 1) {
                if (!this.state.note.id) {
                    this.getNote(this.state.date);
                }
                return
            }
            message.error('备注保存失败：' + x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
        })
    }

    onChangeSelect = (name, value) => {
        let data = this.state.data;
        data[0][name] = value.key;
        this.setState({
            data
        });
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table5_5', 1.5, '5.50', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });

    }

    render() {
        const { data, date, print } = this.state;
        const width = document.body.offsetWidth > 2825 ? document.body.offsetWidth - 2400 : 425;

        const inputIndex = [3, 5, 6, 8, 12, 13, 14, 18, 19, 20];
        const percentData = [4, 9, 15, 16,];
        const totalData = [0, 11, 23];
        const columns = [{
            align: "center",
            title: <div>Breakfast Revenue Allocation <br />  早餐及行政酒廊收入分配</div>,
            width,
            fixed: !print && "left",
            dataIndex: 'name',
            key: 'name',
            width,
            render: (text, record, index) => {
                return (
                    <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`} style={{ textAlign: "left" }}>
                        {text}
                    </div>
                )
            }
        }, {
            title: 'Jan 一月',
            align: "center",
            width: 150,
            children: [{
                title: <Select
                    labelInValue
                    style={{ width: "100%" }}
                    defaultValue={{ key: data[0] ? Number(data[0].Jan).toFixed(0).toString() : 1 }}
                    onChange={(value) => {
                        this.onChangeSelect('Jan', value)
                    }}>
                    <Option value="1">Actual实际</Option>
                    <Option value="2">Forecast预测</Option>
                </Select>,
                align: "center",
                width: 150,
                dataIndex: 'Jan',
                key: 'Jan',
                render: (text, record, index) => {
                    const title = ['Jan 一月', { 1: 'Actual实际', 2: 'Forecast预测' }[data[0] ? Number(data[0].Jan).toFixed(4).toString() : 1]];
                    if (inputIndex.includes(index) && !print) {
                        return (
                            <Compared data={{ index: index + 1, key: 'Jan', title, sqlName: "_5_5", name: record.name, type: 'number' }} >
                                <div className="table-color table-color-number">
                                    <InputNumber
                                        className="input-width"
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                        precision={4}
                                        defaultValue={text}
                                        onBlur={(e) => {
                                            let value = Number(e.target.value.replace(/,/g, '') || '0');
                                            value = Number(value.toFixed(4));
                                            this.onChange('Jan', value, index)
                                        }}
                                    />
                                </div>
                            </Compared>
                        )
                    } else {
                        let html = null;
                        if (percentData.includes(index)) {
                            if (Number(text || "0") >= 0) {
                                html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                            }
                        } else {
                            if (Number(text || "0") >= 0) {
                                html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                            }
                        }
                        return (
                            <Compared data={{ index: index + 1, key: 'Jan', title, sqlName: "_5_5", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }} >
                                <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                    {html}
                                </div>
                            </Compared>
                        )
                    }
                }
            }]
        }, {
            title: 'Feb 二月',
            align: "center",
            width: 150,
            children: [{
                title: <Select
                    labelInValue
                    style={{ width: "100%" }}
                    defaultValue={{ key: data[0] ? Number(data[0].Feb).toFixed(0).toString() : 1 }}
                    onChange={(value) => {
                        this.onChangeSelect('Feb', value)
                    }}>
                    <Option value="1">Actual实际</Option>
                    <Option value="2">Forecast预测</Option>
                </Select>,
                align: "center",
                width: 150,
                dataIndex: 'Feb',
                key: 'Feb',
                render: (text, record, index) => {
                    const title = ['Feb 二月', { 1: 'Actual实际', 2: 'Forecast预测' }[data[0] ? Number(data[0].Feb).toFixed(4).toString() : 1]];
                    if (inputIndex.includes(index) && !print) {
                        return (
                            <Compared data={{ index: index + 1, key: 'Feb', title, sqlName: "_5_5", name: record.name, type: 'number' }} >
                                <div className="table-color table-color-number">
                                    <InputNumber
                                        className="input-width"
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                        precision={4}
                                        defaultValue={text}
                                        onBlur={(e) => {
                                            let value = Number(e.target.value.replace(/,/g, '') || '0');
                                            value = Number(value.toFixed(4));
                                            this.onChange('Feb', value, index)
                                        }}
                                    />
                                </div>
                            </Compared>
                        )
                    } else {
                        let html = null;
                        if (percentData.includes(index)) {
                            if (Number(text || "0") >= 0) {
                                html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                            }
                        } else {
                            if (Number(text || "0") >= 0) {
                                html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                            }
                        }
                        return (
                            <Compared data={{ index: index + 1, key: 'Feb', title, sqlName: "_5_5", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }} >
                                <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                    {html}
                                </div>
                            </Compared>
                        )
                    }
                }
            }]
        }, {
            title: 'Mar 三月',
            align: "center",
            width: 150,
            children: [{
                title: <Select
                    labelInValue
                    style={{ width: "100%" }}
                    defaultValue={{ key: data[0] ? Number(data[0].Mar).toFixed(0).toString() : 1 }}
                    onChange={(value) => {
                        this.onChangeSelect('Mar', value)
                    }}>
                    <Option value="1">Actual实际</Option>
                    <Option value="2">Forecast预测</Option>
                </Select>,
                align: "center",
                width: 150,
                dataIndex: 'Mar',
                key: 'Mar',
                render: (text, record, index) => {
                    const title = ['Mar 三月', { 1: 'Actual实际', 2: 'Forecast预测' }[data[0] ? Number(data[0].Mar).toFixed(4).toString() : 1]];
                    if (inputIndex.includes(index) && !print) {
                        return (
                            <Compared data={{ index: index + 1, key: 'Mar', title, sqlName: "_5_5", name: record.name, type: 'number' }} >
                                <div className="table-color table-color-number">
                                    <InputNumber
                                        className="input-width"
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                        precision={4}
                                        defaultValue={text}
                                        onBlur={(e) => {
                                            let value = Number(e.target.value.replace(/,/g, '') || '0');
                                            value = Number(value.toFixed(4));
                                            this.onChange('Mar', value, index)
                                        }}
                                    />
                                </div>
                            </Compared>
                        )
                    } else {
                        let html = null;
                        if (percentData.includes(index)) {
                            if (Number(text || "0") >= 0) {
                                html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                            }
                        } else {
                            if (Number(text || "0") >= 0) {
                                html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                            }
                        }
                        return (
                            <Compared data={{ index: index + 1, key: 'Mar', title, sqlName: "_5_5", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }} >
                                <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                    {html}
                                </div>
                            </Compared>
                        )
                    }
                }
            }]
        }, {
            title: 'Apr 四月',
            align: "center",
            width: 150,
            children: [{
                title: <Select
                    labelInValue
                    style={{ width: "100%" }}
                    defaultValue={{ key: data[0] ? Number(data[0].Apr).toFixed(0).toString() : 1 }}
                    onChange={(value) => {
                        this.onChangeSelect('Apr', value)
                    }}>
                    <Option value="1">Actual实际</Option>
                    <Option value="2">Forecast预测</Option>
                </Select>,
                align: "center",
                width: 150,
                dataIndex: 'Apr',
                key: 'Apr',
                render: (text, record, index) => {
                    const title = ['Apr 四月', { 1: 'Actual实际', 2: 'Forecast预测' }[data[0] ? Number(data[0].Apr).toFixed(4).toString() : 1]];
                    if (inputIndex.includes(index) && !print) {
                        return (
                            <Compared data={{ index: index + 1, key: 'Apr', title, sqlName: "_5_5", name: record.name, type: 'number' }} >
                                <div className="table-color table-color-number">
                                    <InputNumber
                                        className="input-width"
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                        precision={4}
                                        defaultValue={text}
                                        onBlur={(e) => {
                                            let value = Number(e.target.value.replace(/,/g, '') || '0');
                                            value = Number(value.toFixed(4));
                                            this.onChange('Apr', value, index)
                                        }}
                                    />
                                </div>
                            </Compared>
                        )
                    } else {
                        let html = null;
                        if (percentData.includes(index)) {
                            if (Number(text || "0") >= 0) {
                                html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                            }
                        } else {
                            if (Number(text || "0") >= 0) {
                                html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                            }
                        }
                        return (<Compared data={{ index: index + 1, key: 'Apr', title, sqlName: "_5_5", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }} >
                            <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                {html}
                            </div>
                        </Compared>
                        )
                    }
                }
            }]
        }, {
            title: 'May 五月',
            align: "center",
            width: 150,
            children: [{
                title: <Select
                    labelInValue
                    style={{ width: "100%" }}
                    defaultValue={{ key: data[0] ? Number(data[0].May).toFixed(0).toString() : 1 }}
                    onChange={(value) => {
                        this.onChangeSelect('May', value)
                    }}>
                    <Option value="1">Actual实际</Option>
                    <Option value="2">Forecast预测</Option>
                </Select>,
                align: "center",
                width: 150,
                dataIndex: 'May',
                key: 'May',
                render: (text, record, index) => {
                    const title = ['May 五月', { 1: 'Actual实际', 2: 'Forecast预测' }[data[0] ? Number(data[0].May).toFixed(4).toString() : 1]];
                    if (inputIndex.includes(index) && !print) {
                        return (
                            <Compared data={{ index: index + 1, key: 'May', title, sqlName: "_5_5", name: record.name, type: 'number' }} >
                                <div className="table-color table-color-number">
                                    <InputNumber
                                        className="input-width"
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                        precision={4}
                                        defaultValue={text}
                                        onBlur={(e) => {
                                            let value = Number(e.target.value.replace(/,/g, '') || '0');
                                            value = Number(value.toFixed(4));
                                            this.onChange('May', value, index)
                                        }}
                                    />
                                </div>
                            </Compared>
                        )
                    } else {
                        let html = null;
                        if (percentData.includes(index)) {
                            if (Number(text || "0") >= 0) {
                                html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                            }
                        } else {
                            if (Number(text || "0") >= 0) {
                                html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                            }
                        }
                        return (
                            <Compared data={{ index: index + 1, key: 'May', title, sqlName: "_5_5", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }} >
                                <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                    {html}
                                </div>
                            </Compared>
                        )
                    }
                }
            }]
        }, {
            title: 'Jun 六月',
            align: "center",
            width: 150,
            children: [{
                title: <Select
                    labelInValue
                    style={{ width: "100%" }}
                    defaultValue={{ key: data[0] ? Number(data[0].Jun).toFixed(0).toString() : 1 }}
                    onChange={(value) => {
                        this.onChangeSelect('Jun', value)
                    }}>
                    <Option value="1">Actual实际</Option>
                    <Option value="2">Forecast预测</Option>
                </Select>,
                align: "center",
                width: 150,
                dataIndex: 'Jun',
                key: 'Jun',
                render: (text, record, index) => {
                    const title = ['Jun 六月', { 1: 'Actual实际', 2: 'Forecast预测' }[data[0] ? Number(data[0].Jun).toFixed(4).toString() : 1]];
                    if (inputIndex.includes(index) && !print) {
                        return (
                            <Compared data={{ index: index + 1, key: 'Jun', title, sqlName: "_5_5", name: record.name, type: 'number' }} >
                                <div className="table-color table-color-number">
                                    <InputNumber
                                        className="input-width"
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                        precision={4}
                                        defaultValue={text}
                                        onBlur={(e) => {
                                            let value = Number(e.target.value.replace(/,/g, '') || '0');
                                            value = Number(value.toFixed(4));
                                            this.onChange('Jun', value, index)
                                        }}
                                    />
                                </div>
                            </Compared>
                        )
                    } else {
                        let html = null;
                        if (percentData.includes(index)) {
                            if (Number(text || "0") >= 0) {
                                html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                            }
                        } else {
                            if (Number(text || "0") >= 0) {
                                html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                            }
                        }
                        return (
                            <Compared data={{ index: index + 1, key: 'Jun', title, sqlName: "_5_5", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }} >
                                <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                    {html}
                                </div>
                            </Compared>
                        )
                    }
                }
            }]
        }, {
            title: 'Jul 七月',
            align: "center",
            width: 150,
            children: [{
                title: <Select
                    labelInValue
                    style={{ width: "100%" }}
                    defaultValue={{ key: data[0] ? Number(data[0].Jul).toFixed(0).toString() : 1 }}
                    onChange={(value) => {
                        this.onChangeSelect('Jul', value)
                    }}>
                    <Option value="1">Actual实际</Option>
                    <Option value="2">Forecast预测</Option>
                </Select>,
                align: "center",
                width: 150,
                dataIndex: 'Jul',
                key: 'Jul',
                render: (text, record, index) => {
                    const title = ['Jul 七月', { 1: 'Actual实际', 2: 'Forecast预测' }[data[0] ? Number(data[0].Jul).toFixed(4).toString() : 1]];
                    if (inputIndex.includes(index) && !print) {
                        return (
                            <Compared data={{ index: index + 1, key: 'Jul', title, sqlName: "_5_5", name: record.name, type: 'number' }} >
                                <div className="table-color table-color-number">
                                    <InputNumber
                                        className="input-width"
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                        precision={4}
                                        defaultValue={text}
                                        onBlur={(e) => {
                                            let value = Number(e.target.value.replace(/,/g, '') || '0');
                                            value = Number(value.toFixed(4));
                                            this.onChange('Jul', value, index)
                                        }}
                                    />
                                </div>
                            </Compared>
                        )
                    } else {
                        let html = null;
                        if (percentData.includes(index)) {
                            if (Number(text || "0") >= 0) {
                                html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                            }
                        } else {
                            if (Number(text || "0") >= 0) {
                                html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                            }
                        }
                        return (
                            <Compared data={{ index: index + 1, key: 'Jul', title, sqlName: "_5_5", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }} >
                                <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                    {html}
                                </div>
                            </Compared>
                        )
                    }
                }
            }]
        }, {
            title: 'Aug 八月',
            align: "center",
            width: 150,
            children: [{
                title: <Select
                    labelInValue
                    style={{ width: "100%" }}
                    defaultValue={{ key: data[0] ? Number(data[0].Aug).toFixed(0).toString() : 1 }}
                    onChange={(value) => {
                        this.onChangeSelect('Aug', value)
                    }}>
                    <Option value="1">Actual实际</Option>
                    <Option value="2">Forecast预测</Option>
                </Select>,
                align: "center",
                width: 150,
                dataIndex: 'Aug',
                key: 'Aug',
                render: (text, record, index) => {
                    const title = ['Aug 八月', { 1: 'Actual实际', 2: 'Forecast预测' }[data[0] ? Number(data[0].Aug).toFixed(4).toString() : 1]];
                    if (inputIndex.includes(index) && !print) {
                        return (
                            <Compared data={{ index: index + 1, key: 'Aug', title, sqlName: "_5_5", name: record.name, type: 'number' }} >
                                <div className="table-color table-color-number">
                                    <InputNumber
                                        className="input-width"
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                        precision={4}
                                        defaultValue={text}
                                        onBlur={(e) => {
                                            let value = Number(e.target.value.replace(/,/g, '') || '0');
                                            value = Number(value.toFixed(4));
                                            this.onChange('Aug', value, index)
                                        }}
                                    />
                                </div>
                            </Compared>
                        )
                    } else {
                        let html = null;
                        if (percentData.includes(index)) {
                            if (Number(text || "0") >= 0) {
                                html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                            }
                        } else {
                            if (Number(text || "0") >= 0) {
                                html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                            }
                        }
                        return (
                            <Compared data={{ index: index + 1, key: 'Aug', title, sqlName: "_5_5", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }} >
                                <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                    {html}
                                </div>
                            </Compared>
                        )
                    }
                }
            }]
        }, {
            title: 'Sep 九月',
            align: "center",
            width: 150,
            children: [{
                title: <Select
                    labelInValue
                    style={{ width: "100%" }}
                    defaultValue={{ key: data[0] ? Number(data[0].Sep).toFixed(0).toString() : 1 }}
                    onChange={(value) => {
                        this.onChangeSelect('Sep', value)
                    }}>
                    <Option value="1">Actual实际</Option>
                    <Option value="2">Forecast预测</Option>
                </Select>,
                align: "center",
                width: 150,
                dataIndex: 'Sep',
                key: 'Sep',
                render: (text, record, index) => {
                    const title = ['Sep 九月', { 1: 'Actual实际', 2: 'Forecast预测' }[data[0] ? Number(data[0].Sep).toFixed(4).toString() : 1]];
                    if (inputIndex.includes(index) && !print) {
                        return (
                            <Compared data={{ index: index + 1, key: 'Sep', title, sqlName: "_5_5", name: record.name, type: 'number' }} >
                                <div className="table-color table-color-number">
                                    <InputNumber
                                        className="input-width"
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                        precision={4}
                                        defaultValue={text}
                                        onBlur={(e) => {
                                            let value = Number(e.target.value.replace(/,/g, '') || '0');
                                            value = Number(value.toFixed(4));
                                            this.onChange('Sep', value, index)
                                        }}
                                    />
                                </div>
                            </Compared>
                        )
                    } else {
                        let html = null;
                        if (percentData.includes(index)) {
                            if (Number(text || "0") >= 0) {
                                html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                            }
                        } else {
                            if (Number(text || "0") >= 0) {
                                html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                            }
                        }
                        return (
                            <Compared data={{ index: index + 1, key: 'Sep', title, sqlName: "_5_5", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }} >
                                <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                    {html}
                                </div>
                            </Compared>
                        )
                    }
                }
            }]
        }, {
            title: 'Oct 十月',
            align: "center",
            width: 150,
            children: [{
                title: <Select
                    labelInValue
                    style={{ width: "100%" }}
                    defaultValue={{ key: data[0] ? Number(data[0].Oct).toFixed(0).toString() : 1 }}
                    onChange={(value) => {
                        this.onChangeSelect('Oct', value)
                    }}>
                    <Option value="1">Actual实际</Option>
                    <Option value="2">Forecast预测</Option>
                </Select>,
                align: "center",
                width: 150,
                dataIndex: 'Oct',
                key: 'Oct',
                render: (text, record, index) => {
                    const title = ['Oct 十月', { 1: 'Actual实际', 2: 'Forecast预测' }[data[0] ? Number(data[0].Oct).toFixed(4).toString() : 1]];
                    if (inputIndex.includes(index) && !print) {
                        return (
                            <Compared data={{ index: index + 1, key: 'Oct', title, sqlName: "_5_5", name: record.name, type: 'number' }} >
                                <div className="table-color table-color-number">
                                    <InputNumber
                                        className="input-width"
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                        precision={4}
                                        defaultValue={text}
                                        onBlur={(e) => {
                                            let value = Number(e.target.value.replace(/,/g, '') || '0');
                                            value = Number(value.toFixed(4));
                                            this.onChange('Oct', value, index)
                                        }}
                                    />
                                </div>
                            </Compared>
                        )
                    } else {
                        let html = null;
                        if (percentData.includes(index)) {
                            if (Number(text || "0") >= 0) {
                                html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                            }
                        } else {
                            if (Number(text || "0") >= 0) {
                                html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                            }
                        }
                        return (
                            <Compared data={{ index: index + 1, key: 'Oct', title, sqlName: "_5_5", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }} >
                                <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                    {html}
                                </div>
                            </Compared>
                        )
                    }
                }
            }]
        }, {
            title: 'Nov 十一月',
            align: "center",
            width: 150,
            children: [{
                title: <Select
                    labelInValue
                    style={{ width: "100%" }}
                    defaultValue={{ key: data[0] ? Number(data[0].Nov).toFixed(0).toString() : 1 }}
                    onChange={(value) => {
                        this.onChangeSelect('Nov', value)
                    }}>
                    <Option value="1">Actual实际</Option>
                    <Option value="2">Forecast预测</Option>
                </Select>,
                align: "center",
                width: 150,
                dataIndex: 'Nov',
                key: 'Nov',
                render: (text, record, index) => {
                    const title = ['Nov 十一月', { 1: 'Actual实际', 2: 'Forecast预测' }[data[0] ? Number(data[0].Nov).toFixed(4).toString() : 1]];
                    if (inputIndex.includes(index) && !print) {
                        return (
                            <Compared data={{ index: index + 1, key: 'Nov', title, sqlName: "_5_5", name: record.name, type: 'number' }} >
                                <div className="table-color table-color-number">
                                    <InputNumber
                                        className="input-width"
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                        precision={4}
                                        defaultValue={text}
                                        onBlur={(e) => {
                                            let value = Number(e.target.value.replace(/,/g, '') || '0');
                                            value = Number(value.toFixed(4));
                                            this.onChange('Nov', value, index)
                                        }}
                                    />
                                </div>
                            </Compared>
                        )
                    } else {
                        let html = null;
                        if (percentData.includes(index)) {
                            if (Number(text || "0") >= 0) {
                                html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                            }
                        } else {
                            if (Number(text || "0") >= 0) {
                                html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                            }
                        }
                        return (
                            <Compared data={{ index: index + 1, key: 'Nov', title, sqlName: "_5_5", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }} >
                                <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                    {html}
                                </div>
                            </Compared>
                        )
                    }
                }
            }]
        }, {
            title: 'Dec 十二月',
            align: "center",
            width: 150,
            children: [{
                title: <Select
                    labelInValue
                    style={{ width: "100%" }}
                    defaultValue={{ key: data[0] ? Number(data[0].Dec).toFixed(0).toString() : 1 }}
                    onChange={(value) => {
                        this.onChangeSelect('Dec', value)
                    }}>
                    <Option value="1">Actual实际</Option>
                    <Option value="2">Forecast预测</Option>
                </Select>,
                align: "center",
                width: 150,
                dataIndex: 'Dec',
                key: 'Dec',
                render: (text, record, index) => {
                    const title = ['Dec 十二月', { 1: 'Actual实际', 2: 'Forecast预测' }[data[0] ? Number(data[0].Dec).toFixed(4).toString() : 1]];
                    if (inputIndex.includes(index) && !print) {
                        return (
                            <Compared data={{ index: index + 1, key: 'Dec', title, sqlName: "_5_5", name: record.name, type: 'number' }} >
                                <div className="table-color table-color-number">
                                    <InputNumber
                                        className="input-width"
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                        precision={4}
                                        defaultValue={text}
                                        onBlur={(e) => {
                                            let value = Number(e.target.value.replace(/,/g, '') || '0');
                                            value = Number(value.toFixed(4));
                                            this.onChange('Dec', value, index)
                                        }}
                                    />
                                </div>
                            </Compared>
                        )
                    } else {
                        let html = null;
                        if (percentData.includes(index)) {
                            if (Number(text || "0") >= 0) {
                                html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                            }
                        } else {
                            if (Number(text || "0") >= 0) {
                                html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                            }
                        }
                        return (
                            <Compared data={{ index: index + 1, key: 'Dec', title, sqlName: "_5_5", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }} >
                                <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                    {html}
                                </div>
                            </Compared>
                        )
                    }
                }
            }]
        }, {
            title: <div>Whole Year Forecast <br /> 全年预测</div>,
            align: "center",
            width: 200,
            dataIndex: 'whole',
            key: 'whole',
            render: (text, record, index) => {
                const title = ['Whole Year Forecast  全年预测'];
                let html = null;
                if (percentData.includes(index)) {
                    if (Number(text || "0") >= 0) {
                        html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                    } else {
                        html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                    }
                } else {
                    if (Number(text || "0") >= 0) {
                        html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                    } else {
                        html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                    }
                }
                return (
                    <Compared data={{ index: index + 1, key: 'whole', title, sqlName: "_5_5", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }} >
                        <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                            {html}
                        </div>
                    </Compared>
                )
            }
        }, {
            title: <div>Last Year Actual <br /> 去年实际</div>,
            align: "center",
            width: 200,
            dataIndex: 'last',
            key: 'last',
            render: (text, record, index) => {
                const title = ['Last Year Actual  去年实际'];
                if ((inputIndex.includes(index) || index == 7 || index == 1) && index != 6 && !print) {
                    return (
                        <Compared data={{ index: index + 1, key: 'last', title, sqlName: "_5_5", name: record.name, type: 'number' }} >
                            <div className="table-color table-color-number">
                                <InputNumber
                                    className="input-width"
                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                    precision={4}
                                    defaultValue={text}
                                    onBlur={(e) => {
                                        let value = Number(e.target.value.replace(/,/g, '') || '0');
                                        value = Number(value.toFixed(4));
                                        this.onChange('last', value, index)
                                    }}
                                />
                            </div>
                        </Compared>
                    )
                } else {
                    let html = null;
                    if (percentData.includes(index)) {
                        if (Number(text || "0") >= 0) {
                            html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                        } else {
                            html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                        }
                    } else {
                        if (Number(text || "0") >= 0) {
                            html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                        } else {
                            html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                        }
                    }
                    return (
                        <Compared data={{ index: index + 1, key: 'last', title, sqlName: "_5_5", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }} >
                            <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                {html}
                            </div>
                        </Compared>
                    )
                }
            }
        }, {
            title: <div>Variance 差异</div>,
            align: "center",
            width: 200,
            dataIndex: 'variance',
            key: 'variance',
            render: (text, record, index) => {
                const title = ['Variance 差异'];
                let html = null;
                if (Number(text || "0") >= 0) {
                    html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                } else {
                    html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                }
                return (
                    <Compared data={{ index: index + 1, key: 'variance', title, sqlName: "_5_5", name: record.name, type: "percent" }} >
                        <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                            {html}
                        </div>
                    </Compared>
                )
            }
        }];
        return (
            <Spin spinning={this.state.loading} >
                <div className="table table2_1">
                    <Row className="title" id="table5_5" style={{ width: this.state.print ? 2875 : 'auto' }}>
                        <Row>5.5 Breakfast & Club Lounge Revenue Allocation 早餐收入分配</Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true
                                    });
                                    this.getDateData(str)
                                }}
                            />
                        </Row>
                        {data.length > 0 ? <Row
                        ><Table
                                columns={columns}
                                dataSource={data.filter(x => x.name)}
                                size="middle"
                                className="content"
                                bordered
                                id="export5_5"
                                pagination={false}
                                style={{ width: this.state.print ? 2825 : 'auto' }}
                                scroll={this.state.print ? {} : { x: 2825, y: 550 }}
                                rowKey={(record, index) => {
                                    return index
                                }}
                            />
                            <Row style={{ margin: "20px 0", }}>
                                <Row style={{ margin: "10px 0" }}>5.5.1 Comments 备注: </Row>
                                <TextArea
                                    autosize={{ minRows: 4 }}
                                    placeholder="请输入备注！"
                                    defaultValue={this.state.note.note}
                                    onBlur={(e) => {
                                        this.setState({
                                            note: { ...this.state.note, note: e.target.value }
                                        });
                                    }}
                                />
                            </Row>
                        </Row> : ""}

                    </Row>

                    <Row className="table-footer-btn">
                        <Button
                            type="primary"
                            style={{ marginRight: 10 }}
                            onClick={() => {

                                this.setState({ print: true, loading: true }, () => {
                                    ExportExcel({
                                        id: "export5_5",
                                        date,
                                        name: "5.5 Breakfast & Club Lounge Revenue Allocation 早餐收入分配"
                                    });
                                    this.setState({ print: false, loading: false });
                                });

                            }}
                            loading={this.state.print}
                        >导出Excel</Button>
                        <Auth loading={this.state.loading} auth="edit_5_5">
                            <Button
                                type="primary"
                                style={{ marginRight: 10 }}
                                onClick={this.downloadSG}
                                loading={this.state.print}
                            >加入pdf</Button>
                            <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                            >保存</Button>
                        </Auth>
                    </Row>


                </div>
            </Spin>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/5.0/5-5/index.js